<template>
  <div :class="$style.container">
    <ul :class="$style.top">
      <li
        :style="{ color: index !== 1 ? '#000000' : '#59a8f9' }"
        v-for="(item, index) in tags"
        :key="item"
        :class="index === tags.length - 1 ? $style.active : ''"
      >
        {{ item }}
        <i :class="['iconfont', 'icon-rightarrow2f', $style.arrow]" v-if="index < tags.length - 1"></i>
      </li>
    </ul>
    <h4 :class="$style.title">
      <p>
        {{ title }} <span :class="$style.font">{{ subTitle }}</span>
      </p>
      <div style="margin-bottom: 10px">
        <el-button
          class="el-icon-plus"
          type="success"
          @click.stop="handleAddSaves"
          v-if="btnSaves"
          size="small"
          :disabled="disabled"
        >
          <span style="font-weight: bold;margin-left: 5px">保存</span></el-button
        >
        <el-button
          class="el-icon-plus"
          type="success"
          @click.stop="handleAddSum"
          v-if="btnSum"
          size="small"
          :disabled="disabled"
        >
          <span style="font-weight: bold;margin-left: 5px">小结计划</span></el-button
        >
        <el-button
          class="el-icon-plus"
          type="success"
          @click.stop="handleAddTod"
          v-if="btnTod"
          size="small"
          :disabled="disabled"
        >
          <span style="font-weight: bold;margin-left: 5px">今日计划</span></el-button
        >
        <el-button
          class="el-icon-plus"
          type="success"
          @click.stop="handleAddTom"
          v-if="btnTom"
          size="small"
          :disabled="disabled"
        >
          <span style="font-weight: bold;margin-left: 5px">明日计划</span></el-button
        >
        <el-button
          class="el-icon-plus"
          type="success"
          @click.stop="handleAdd"
          v-if="btnAdd"
          size="small"
          :disabled="disabled"
        >
          <span style="font-weight: bold;margin-left: 5px">新增</span></el-button
        >
        <el-button type="success" @click.stop="handleCompleteClick" v-if="complete" size="small" :disabled="disabled"
          >完成</el-button
        >
        <el-button
          :type="cusApproval"
          @click.stop="handleApprovalClick"
          v-if="btnApproval"
          size="small"
          :disabled="disabled"
          >审批</el-button
        >
        <el-button :type="cusRecall" @click.stop="handleRecallClick" v-if="btnRecall" size="small" :disabled="disabled"
          >撤回</el-button
        >
        <el-button
          type="success"
          @click.stop="handleAgreeClick"
          v-if="btnAgree"
          size="small"
          class="icon"
          :disabled="successDisabled"
        >
          <i :class="['iconfont', 'el-icon-success', $style.back]" style="position: relative;top:1px"></i>
          同意</el-button
        >
        <el-button
          type="danger"
          @click.stop="handleRefuseClick"
          v-if="btnRefuse"
          size="small"
          class="icon"
          :disabled="refuseDisabled"
        >
          <i :class="['iconfont', 'el-icon-error', $style.back]" style="position: relative;top:1px"></i>
          拒绝</el-button
        >
        <el-button
          :type="cusSubmit"
          @click.stop="handleSubmitClick"
          v-if="btnSubmit"
          size="small"
          id="submit"
          class="icon"
          :disabled="submitDisabled"
        >
          <i :class="['iconfont', 'el-icon-s-promotion', $style.back]" style="position: relative;top:1px"></i>
          提交</el-button
        >
        <el-button type="danger" @click.stop="handleRepealClick" v-if="btnRepeal" size="small" :disabled="disabled"
          >撤销</el-button
        >
        <el-button
          type="warning"
          @click.stop="handleCalculateDataClick"
          v-if="btnCalculateData"
          size="small"
          :disabled="disabled"
          >重新计算统计数据</el-button
        >
        <el-button :type="cusSave" @click.stop="handleSaveClick" v-if="btnSave" size="small" :disabled="upDataDisabled"
          >保存
        </el-button>
        <el-button
          type="danger"
          @click.stop="handleDeleteClick"
          v-if="btnDelete"
          size="small"
          id="delete"
          :disabled="upDataDisabled"
          >删除
        </el-button>
        <el-button
          type="danger"
          @click.stop="handleBackClick"
          v-if="btnBack"
          size="small"
          style="margin-left: 30px"
          class="icon"
        >
          <i :class="['iconfont', 'icon-back', $style.back]" style="position: relative;top:1px"></i>
          返回</el-button
        >
        <el-button
          class="el-icon-plus"
          type="success"
          @click.stop="handleAddPlan"
          v-if="btnAddPlan"
          size="small"
          :disabled="disabled"
        >
          <span style="font-weight: bold;margin-left: 5px">新增计划</span></el-button
        >
        <el-button
          class="el-icon-plus"
          type="success"
          @click.stop="handleAddRecord"
          v-if="btnAddRecord"
          size="small"
          id="addRecord"
          :disabled="disabled"
        >
          <span style="font-weight: bold;margin-left: 5px">新增记录</span></el-button
        >
      </div>
    </h4>
  </div>
</template>
<script>
export default {
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    cusApproval: {
      type: String,
      default: 'info',
    },
    cusSubmit: {
      type: String,
      default: 'warning',
    },
    cusRecall: {
      type: String,
      default: 'info',
    },
    cusSave: {
      type: String,
      default: 'primary',
    },
    btnSubmit: {
      type: Boolean,
      default: false,
    },
    btnApproval: {
      type: Boolean,
      default: false,
    },
    btnRecall: {
      type: Boolean,
      default: false,
    },
    btnAgree: {
      type: Boolean,
      default: false,
    },
    btnRefuse: {
      type: Boolean,
      default: false,
    },
    btnRepeal: {
      type: Boolean,
      default: false,
    },
    btnSave: {
      type: Boolean,
      default: false,
    },
    btnDelete: {
      type: Boolean,
      default: false,
    },
    btnBack: {
      type: Boolean,
      default: false,
    },
    btnCalculateData: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      defalut: false,
    },
    btnSaves: {
      type: Boolean,
      default: false,
    },
    btnSum: {
      type: Boolean,
      default: false,
    },
    btnTod: {
      type: Boolean,
      default: false,
    },
    btnTom: {
      type: Boolean,
      default: false,
    },
    btnAdd: {
      type: Boolean,
      default: false,
    },
    btnAddRecord: {
      type: Boolean,
      default: false,
    },
    btnAddPlan: {
      type: Boolean,
      default: false,
    },
    submitDisabled: {
      type: Boolean,
      default: false,
    },
    upDataDisabled: {
      type: Boolean,
      default: false,
    },
    successDisabled: {
      type: Boolean,
      default: false,
    },
    refuseDisabled: {
      type: Boolean,
      default: false,
    },
    complete: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleSubmitClick() {
      this.$emit('btnSubmitClick')
    },
    handleApprovalClick() {
      this.$emit('btnApprovalClick')
    },
    handleRecallClick() {
      this.$emit('btnRecallClick')
    },
    handleAgreeClick() {
      this.$emit('btnAgreeClick')
    },
    handleRefuseClick() {
      this.$emit('btnRefuseClick')
    },
    handleRepealClick() {
      this.$emit('btnRepealClick')
    },
    handleSaveClick() {
      this.$emit('btnSaveClick')
    },
    handleDeleteClick() {
      this.$emit('btnDeleteClick')
    },
    handleCalculateDataClick() {
      this.$emit('btnCalculateDataClick')
    },
    handleCompleteClick() {
      this.$emit('btnCompleteClick')
    },
    handleBackClick() {
      this.$emit('btnBackClick')
    },
    handleAddSaves() {
      this.$emit('btnSaves')
    },
    handleAddSum() {
      this.$emit('btnSum')
    },
    handleAddTod() {
      this.$emit('btnTod')
    },
    handleAddTom() {
      this.$emit('btnTom')
    },
    handleAdd() {
      this.$emit('btnAdd')
    },
    handleAddRecord() {
      this.$emit('btnAddRecord')
    },
    handleAddPlan() {
      this.$emit('btnAddPlan')
    },
  },
}
</script>
<style lang="scss" module>
@import '../assets/css/default';
.container {
  .top {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    li {
      color: #000000;
      text-align: left;
      font-size: $TopTitleFontSize;
      .arrow {
        font-size: $TopTitleFontSize;
        color: #babac2;
        vertical-align: bottom;
      }
    }
    .active {
      color: #59a8f9;
    }
  }
  .title {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    font-size: $TopSubFontSize;
    color: #000000;
    text-align: left;
    margin: 10px 0px;
    border-bottom: 2px dotted #e7eaec;
    .font {
      color: #3b99f7;
      &:before {
        display: inline-block;
        content: '';
        background: #3b99f7;
        height: $TopSubFontSize;
        width: 1px;
        margin: 0 10px;
        vertical-align: top;
      }
    }
    .back {
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>
<style scoped>
#addRecord {
  color: #fff;
  background-color: #4a90e2;
  border-color: #4a90e2;
}
#addRecord:hover {
  background: #66b1ff;
  border-color: #66b1ff;
  color: #fff;
}
#delete {
  color: #fff;
  background-color: #ed3b3f;
  border-color: #ed3b3f;
}
#delete:hover {
  color: #fff;
  background-color: #f56c6c;
  border-color: #f56c6c;
}
#submit {
  color: #fff;
  background-color: #ff9901;
  border-color: #ff9901;
}
#submit:hover {
  background: #ebb563;
  border-color: #ebb563;
  color: #fff;
}
.el-button {
  font-size: 13px;
}
.el-button--small {
  padding: 9px 12px;
}
.icon {
  height: 33px;
  position: relative;
  top: 1px;
  padding: 7px 12px;
}
.icon >>> span {
  position: relative;
  top: -1px;
}
</style>



// WEBPACK FOOTER //
// src/components/navBar.vue